import { request } from '@app/services';

export interface GooglePlacePrediction {
  placeId: string;
  description: string;
}

export interface ParsedGoogleAddress {
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  pinCode: string;
  country: string;
  countryCode: string;
  formattedAddress: string;
}

export async function fetchPlacePredictions(input: string): Promise<GooglePlacePrediction[]> {
  if (!input.trim()) {
    return [];
  }

  const result: { data?: { predictions?: GooglePlacePrediction[] } } = await request.get(
    '/maps/places/autocomplete',
    {
      params: { q: input },
    }
  );

  return result.data?.predictions ?? [];
}

export async function fetchPlaceDetails(placeId: string): Promise<ParsedGoogleAddress | null> {
  if (!placeId.trim()) {
    return null;
  }

  const result: { data?: { details?: ParsedGoogleAddress | null } } = await request.get(
    '/maps/places/details',
    {
      params: { placeId },
    }
  );

  return result.data?.details ?? null;
}
